/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/validar';

// ---------------- Saga's response ----------------
function fetchValidarSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchValidarError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchValidar = createAction('fetchValidar');

// ------------- connection ------------- //

const validarReducer = createSlice({
  name: 'Validar',
  initialState,
  reducers: {
    fetchValidarSuccess,
    fetchValidarError,
  },
});

export const validarAction = {
  ...validarReducer.actions,
  fetchValidar,
};

export default validarReducer.reducer;